import React from "react";
import { MotoristaData, Disponibilidade } from "./types"
import styles from "../Styles/DriverProfile.module.css"

interface VehicleAvailabilityTabProps {
  motoristaData: MotoristaData;
  disponibilidades: Disponibilidade[];
  BASE_URL: string;
  formatDate: (dateStr: string) => string;
}

const VehicleAvailabilityTab: React.FC<VehicleAvailabilityTabProps> = ({
  motoristaData,
  disponibilidades,
  BASE_URL,
  formatDate,
}) => {
  const veiculo = motoristaData.veiculo;

  if (!veiculo) return <p>No vehicle assigned.</p>;

  return (
    <div className="card settings mb-0">
      <div className="card-header">
        <h6>Vehicle & Availability</h6>
      </div>
      <div className="card-body">
        {/* Veículo */}
        <div className={styles.section}>
          <h6 className={styles.sectionTitle}>Vehicle</h6>

          {veiculo.fotoUrl && (
            <img
              src={`${BASE_URL}${veiculo.fotoUrl}`}
              alt="Vehicle"
              className={styles.avatarImg}
              style={{ maxWidth: 200, marginBottom: 10 }}
            />
          )}

          <div className={styles.infoGrid}>
            <div><strong>Model:</strong> {veiculo.modelo}</div>
            <div><strong>Plate:</strong> {veiculo.placa}</div>
            <div><strong>Capacity:</strong> {veiculo.capacidade}</div>
            <div><strong>Color:</strong> {veiculo.cor}</div>
            <div><strong>Status:</strong> {veiculo.status}</div>
            {veiculo.motivoReprovacao && (
              <div><strong>Rejection Reason:</strong> {veiculo.motivoReprovacao}</div>
            )}
            <div><strong>Registration #:</strong> {veiculo.numeroMatricula}</div>
            <div><strong>Chassis #:</strong> {veiculo.numeroChassi}</div>
            <div><strong>RNAAT License:</strong> {veiculo.numeroLicencaRnaat}</div>
            <div><strong>Insurance #:</strong> {veiculo.numeroApolice}</div>
          </div>

          {/* Links */}
          <div className={styles.documentLinks}>
            {veiculo.livreteUrl && (
              <a href={`${BASE_URL}${veiculo.livreteUrl}`} target="_blank" rel="noreferrer">Livrete</a>
            )}
            {veiculo.seguroUrl && (
              <a href={`${BASE_URL}${veiculo.seguroUrl}`} target="_blank" rel="noreferrer">Insurance</a>
            )}
            {veiculo.licencaRnaatUrl && (
              <a href={`${BASE_URL}${veiculo.licencaRnaatUrl}`} target="_blank" rel="noreferrer">RNAAT License</a>
            )}
            {veiculo.seguroOcupantesUrl && (
              <a href={`${BASE_URL}${veiculo.seguroOcupantesUrl}`} target="_blank" rel="noreferrer">Occupants Insurance</a>
            )}
          </div>
        </div>

        {/* Disponibilidade */}
        <div className={styles.section} style={{ marginTop: 20 }}>
          <h6 className={styles.sectionTitle}>Availability</h6>
          {disponibilidades.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Start</th>
                    <th>End</th>
                  </tr>
                </thead>
                <tbody>
                  {disponibilidades.map(d => (
                    <tr key={d.id}>
                      <td>{formatDate(d.data)}</td>
                      <td>{d.horaInicio}</td>
                      <td>{d.horaFim}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No availability set.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleAvailabilityTab;
